import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        stroke: "currentColor",
        "stroke-linejoin": "round",
        "stroke-width": "1.5",
        d: "M12 20c3.294 0 6-2.773 6-6.333 0-.874-.042-1.811-.498-3.267s-.547-1.644-1.03-2.543c-.206 1.835-1.308 2.6-1.588 2.828 0-.238-.666-2.867-1.677-4.44C12.215 4.7 10.865 3.686 10.074 3c0 1.305-.345 3.244-.84 4.233-.494.988-.587 1.024-1.205 1.76-.618.735-.901.962-1.418 1.855-.517.892-.611 2.08-.611 2.955C6 17.363 8.706 20 12 20Z"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }